window.AS || (window.AS = {});
window.o_global || (window.o_global = {});
window.o_util || (window.o_util = {});
const { AS: o, o_global: w, o_util: i } = window;
export {
  o as AS,
  w as o_global,
  i as o_util
};
